const isIntersectionSupported = typeof window.IntersectionObserver !== 'undefined'
if (!isIntersectionSupported) {
  console.warn('[v-impression] Broswer is not compatible with InstersectionObserver api, impression will ed called immediatetly')
}

const intersectionOptions = {
  root: null,
  rootMargin: '0px 0px 0px 0px',
  threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
}

// let device = new MobileDetect(window.navigator.userAgent)
// if (device.mobile()) {
//   intersectionOptions.rootMargin = '-50px 0px -82px 0px'
// } else {
//   intersectionOptions.rootMargin = '-50px 0px 0px 0px'
// }

const Inview = {
  observe (element, options = {}) {
    let callback = null
    let threshold = 0.2
    let data = {}
    if (typeof options === 'function') {
      callback = options
    } else if (typeof options.callback === 'function') {
      callback = options.callback || null
      threshold = options.threshold || threshold
      data = options.data || {}
    }
    if (!callback) {
      return
    }
    if (!isIntersectionSupported) {
      callback(JSON.parse(JSON.stringify(data)))
      return
    }
    let observer = new IntersectionObserver(function (entries) {
      Array.prototype.slice.call(entries)
        .some(function (entry) {
          if (entry.intersectionRatio > threshold) {
            callback(JSON.parse(JSON.stringify(data)))
            observer.unobserve(entry.target)
            observer.disconnect()
            element = null
            options = null
            observer = null
          }
        }, this)
    }, intersectionOptions)

    let onLoadToObserve = function (event) {
      window.removeEventListener('load', onLoadToObserve)
      observer.observe(element)
      onLoadToObserve = null
    }
    if (document.readyState !== 'complete') {
      window.addEventListener('load', onLoadToObserve)
    } else {
      observer.observe(element)
    }
  }
}

export default {
  bind (el, binding, vnode, oldVnode) {
    // [bind hook]
    Inview.observe(el, binding.value)
  },
  inserted (el, binding, vnode, oldVnode) {
    // [inserted hook]
  },
  update (el, binding, vnode, oldVnode) {
    // [update hook]
  },
  componentUpdated (el, binding, vnode, oldVnode) {
    // [componentUpdated hook]
  },
  unbind (el, binding, vnode, oldVnode) {
    // [unbind hook]
  }
}
